/* Push-Einstellungen des angemeldeten Nutzers.
 *
 * Tabelle `push_preferences`, eine Zeile je Nutzer:
 *   disabled_types  Typen, für die er KEINEN Push will (leer = alles an)
 *   language        'de' | 'en' — Sprache des Push-Textes
 * Keine Zeile heißt: alles an, Englisch.
 *
 * Die Datenbankregeln lassen jeden nur die eigene Zeile lesen und ändern
 * (supabase/push-preferences.sql). Diese Einstellungen steuern NUR den Push;
 * die Glocke in der App zeigt weiterhin alles. Wer den Push verschickt und die
 * Einstellungen beim Versand prüft, ist die Edge Function notify.
 *
 * Gespeichert wird per Upsert mit nur den Feldern, die sich ändern: Wer die
 * Sprache setzt, lässt die ausgeschalteten Typen unberührt und umgekehrt.
 */

import { supabase } from './client.js';

/**
 * @returns {Promise<{disabledTypes: string[], language: string|null}>}
 *   Ohne Zeile: alles an, keine Sprache.
 * @throws {Error} 'loadFailed'
 */
export async function loadOwnPushPreferences(userId) {
  if (!supabase || !userId) return { disabledTypes: [], language: null };

  const { data, error } = await supabase
    .from('push_preferences')
    .select('disabled_types, language')
    .eq('user_id', userId)
    .maybeSingle();

  if (error) {
    console.error('[pushPreferences] Laden fehlgeschlagen:', error.message);
    throw new Error('loadFailed');
  }
  return {
    disabledTypes: Array.isArray(data?.disabled_types) ? data.disabled_types : [],
    language: data?.language ?? null,
  };
}

/**
 * @param {string} userId
 * @param {{disabledTypes?: string[], language?: string}} patch  nur was sich ändert
 * @throws {Error} 'saveFailed'
 */
export async function saveOwnPushPreferences(userId, patch) {
  if (!supabase || !userId) throw new Error('notConnected');

  const row = { user_id: userId };
  if (patch.disabledTypes !== undefined) row.disabled_types = patch.disabledTypes;
  if (patch.language !== undefined) row.language = patch.language;

  const { error } = await supabase.from('push_preferences').upsert(row, { onConflict: 'user_id' });
  if (error) {
    console.error('[pushPreferences] Speichern fehlgeschlagen:', error.message);
    throw new Error('saveFailed');
  }
}
